export default __webpack_public_path__ + "static/media/Yellow0004.9a883271.png";